
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/duplicate-items",
      function () {
        return require("private-next-pages/docs/link/duplicate-items.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/duplicate-items"])
      });
    }
  